export class DefaultAssetRepresentation {
  name: string;
  description: string;
  icon: any[];
}
